import React, { createContext, useContext, useState } from "react";

const UserContext = createContext();
export const useUserContext = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
	const [userDetails, setUserDetails] = useState({
		isCustomerUser: null,
		customerName: "",
		username: "",
		userIdToken: ""
	});

	return (
		<UserContext.Provider value={{ userDetails, setUserDetails }}>
			{children}
		</UserContext.Provider>
	);
};
